import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import PersonIcon from '@mui/icons-material/Person'
import PersonOutlineIcon from '@mui/icons-material/PersonOutlined'

import { Tooltip } from './Tooltip'

const OwnerIcon = () => (
  <Tooltip tabIndex={0} title="Record owner" placement="left" role="img" describeChild>
    <AdminPanelSettingsIcon
      fontSize="small"
      sx={{ opacity: 0.66 }}
      tabIndex={0}
      aria-hidden="false"
      aria-label="Admin settings"
    />
  </Tooltip>
)
const LeadIcon = () => (
  <Tooltip tabIndex={0} title="Record lead investigator" placement="top" role="img" describeChild>
    <PersonIcon
      fontSize="small"
      sx={{ opacity: 0.66 }}
      tabIndex={0}
      aria-hidden="false"
      aria-label="Record lead investigator"
    />
  </Tooltip>
)

const CollaboratorIcon = () => (
  <Tooltip title="Record collaborator" placement="right" role="img" describeChild>
    <PersonOutlineIcon
      fontSize="small"
      sx={{ opacity: 0.66 }}
      tabIndex={0}
      aria-hidden="false"
      aria-label="Record collaborator"
    />
  </Tooltip>
)

type Props = {
  isOwner: boolean
  isLead: boolean
}
export const RecordRoleIcon = ({ isOwner, isLead }: Props) => {
  if (isOwner || isLead) {
    return (
      <>
        {isOwner && <OwnerIcon />}
        {isLead && <LeadIcon />}
      </>
    )
  }
  return <CollaboratorIcon />
}
